<template>
  <tile
    double-border
    class="tile"
    @click.native="clicked"
  >
    <template v-slot:icon>
      <component v-if="group.icon" :is="group.icon" class="w-100" is-switched-on />
      <font-awesome-icon v-else icon="question-circle" size="4x" class="text-black-50" />
    </template>

    <template v-slot:action-buttons>
      <round-icon-button
        v-if="!serviceGroupTileClickNavigatesToNextLevel"
        class="m-4"
        :class="[{ 'hiding-btn': !$isMobile }]"
        icon="th"
        @click.stop="navigateToServices"
      />
      <round-icon-button
        v-if="serviceGroupTileClickNavigatesToNextLevel"
        class="m-4"
        :class="[{ 'hiding-btn': !$isMobile }]"
        icon="bars"
        transform="shrink-6 right-0.9"
        @click.stop="showControlPanel"
      />
    </template>

    <template v-slot:line1>
      {{ group.name }}
    </template>

    <template v-slot:line2>
      <group-status :group="group" :place="place" />
    </template>
  </tile>
</template>

<script>
import ControlPanel from '@/components/service-groups/ControlPanel';
import RoundIconButton from '@/components/utils/RoundIconButton';
import GroupStatus from '@/components/service-groups/GroupStatus';
import Tile from '@/components/utils/tiles/Tile';

export default {
  name: 'ServiceGroupTile',
  props: {
    place: {
      required: true,
      type: Object,
    },
    group: {
      required: true,
      type: Object,
    },
  },
  computed: {
    serviceGroupTileClickNavigatesToNextLevel() {
      return this.$store.state.app.navigationSettings.serviceGroupTileClickNavigatesToNextLevel;
    },
  },
  methods: {
    clicked() {
      if (this.serviceGroupTileClickNavigatesToNextLevel) {
        this.navigateToServices();
      } else {
        this.showControlPanel();
      }
    },
    navigateToServices() {
      this.$router.push({ name: 'service-group', params: { serviceGroupId: this.group.id } });
    },
    showControlPanel() {
      this.$showPanel({
        component: ControlPanel,
        width: '500px',
        cssClass: 'panel-1-custom-class',
        keepAlive: false,
        props: {
          serviceGroup: this.group,
          place: this.place,
        },
      });
    },
  },
  components: {
    Tile,
    GroupStatus,
    RoundIconButton,
  },
};
</script>

<style lang="scss" scoped>
</style>
